import { createTheme, responsiveFontSizes } from "@material-ui/core/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "#9b9b9b",
      light: "#ffffff",
      dark: "#000",
    },
    background: {
      grey: "rgb(249, 249, 249)",
      dark: "#5B5F61",
      drawer: "#ee1d1b",
    },
    border: {
      main: "#ced4da",
      dark: "#000",
    },
    error: {
      main: "#f25e74",
    },
    text: {
      primary: "#000000",
      secondary: "#fff",
      alternative: "#666a6c",
      placeholder: "#8E969A"
    },
    button: {
      main: "#ee1d1b",
    }
  },
  shadows: [
    "none",
    "0px 1px 4px 0px rgba(0, 0, 0, 0.25)",
    "0px 2px 6px 0px rgba(69, 74, 82, 0.25)",
  ],
  typography: {
    fontWeightBold: 700,
    fontWeightMedium: 500,
    h1: {
      fontSize: "2em",
      fontWeight: 900,
    },
    body2: {
      fontSize: "1rem"
    }
  },
  shape: {
    borderRadius: 3,
    borderRadiusSecondary: 4,
    borderRadiusAlt: 6,
  },
  zIndex: {
    content: 50,
    phoneNumber: 100,
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 200,
        textTransform: "inherit",
      },
      containedPrimary: {
        color: "#222",
        backgroundColor: "#ee1d1b",
        "&:hover": {
          backgroundColor: "#ee1d1b",
        },
        fontWeight: 600,
      },
      textSecondary: {
        color: "rgb(102, 106, 108)",
        textDecoration: "underline",
      },
    },
    MuiLink: {
      root: {
        color: "#f1f1f1",
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
